import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e80e3a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["viewBox"]
const _hoisted_2 = ["xlink:href", "width", "height", "transform"]

import { isExternal as external } from '@/utils/validate'
import { computed, ref, watch, nextTick, onMounted } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
  icon: {
    type: String,
    required: true
  },
  fit: { type: Boolean, default: false },
  className: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props
const isExternal = computed(() => external(props.icon))
const styleExternalIcon = computed(() => ({
  mask: `url(${props.icon}) no-repeat 50% 50%`,
  '-webkit-mask': `url(${props.icon})`
}))
const iconName = computed(() => `#icon-${props.icon}`)
const shape = ref<SVGGraphicsElement>()
const shapeTransform = ref<string>()
// 折叠导航按图形实际边界统一大小，其他位置保持原有图标表现。
const fitShape = async () => {
  shapeTransform.value = undefined
  await nextTick()
  if (!props.fit || !shape.value) return
  const box = shape.value.getBBox()
  const edge = Math.max(box.width, box.height)
  if (edge <= 0) return
  const scale = 1024 / edge
  shapeTransform.value = `translate(${512 - (box.x + box.width / 2) * scale} ${512 - (box.y + box.height / 2) * scale}) scale(${scale})`
}
onMounted(fitShape)
watch(() => [props.icon, props.fit], fitShape)

return (_ctx: any,_cache: any) => {
  return (isExternal.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle(styleExternalIcon.value),
        class: _normalizeClass(["svg-external-icon svg-icon", __props.className])
      }, null, 6))
    : (_openBlock(), _createElementBlock("svg", {
        key: 1,
        class: _normalizeClass(["svg-icon", __props.className]),
        viewBox: __props.fit ? '0 0 1024 1024' : undefined,
        "aria-hidden": "true"
      }, [
        _createElementVNode("use", {
          ref_key: "shape",
          ref: shape,
          "xlink:href": iconName.value,
          width: __props.fit ? 1024 : undefined,
          height: __props.fit ? 1024 : undefined,
          transform: shapeTransform.value
        }, null, 8, _hoisted_2)
      ], 10, _hoisted_1))
}
}

})